import React, { Component } from 'react'
import Axios from 'axios'

import ContactUsDesktop from './Desktop/ContactUs'
import ContactUsMobile from './Mobile/ContactUs'

import firebase from '../firebase'

const INTENTION_NONE = null;
const INTENTION_WORK = 'working';
const INTENTION_JOIN = 'joining';
const INTENTION_ELSE = 'etc';

export default class ContactUs extends Component {
	

	state = {
		topic: INTENTION_NONE,
		name: '',
		email: '',
		message: '',
		companyName: '',
		address: '',
		contactNo: '',
		status: '',
	}

	componentDidMount() {
		const infoRef = firebase.database().ref('company-info');

		infoRef.once('value').then((snapshot) => {
			let companyInfo = snapshot.val();

			this.setState({
				companyName: companyInfo.name,
				address: companyInfo.address,
				contactNo: companyInfo.contactNo,
			});
		});
	}

	setTopic = (event) => {
		let value = event.target.value;

		if (value.trim().length === 0) {
			value = null;
		}

		this.setState({
			topic: value
		});
	}

	setName = (event) => {
		this.setState({
			name: event.target.value
		});
	}

	setEmail = (event) => {
		this.setState({
			email: event.target.value
		});
	}

	setMessage = (event) => {
		this.setState({
			message: event.target.value
		});
	}

	sendMessage = () => {

		let topic = '';
		switch(this.state.topic) {
			case INTENTION_NONE:
				topic = 'No Topic Chosen.';
				break;
			case INTENTION_JOIN:
				topic = 'Joining your team.';
				break;
			case INTENTION_WORK:
				topic = 'Working together.';
				break;
			case INTENTION_ELSE:
				topic = 'Something else.';
				break;
		}

		const data = {
			topic: topic,
			name: this.state.name,
			email: this.state.email,
			message: this.state.message
		}

		this.setState({
			status: 'Sending message...'
		})

		Axios.post('https://us-central1-kindred-85598.cloudfunctions.net/submit', data).then(res => {
			this.setState({
				status: 'Your message has been sent!'
			})
		})
		.catch(error => {
			this.setState({
				status: 'Your message failed to send!'
			})
		})

		return;
	}

  render() {

	if (this.props.isMobile) {
		return (
			<ContactUsMobile {...this.props}
				setTopic={this.setTopic}
				setName={this.setName}
				setEmail={this.setEmail}
				setMessage={this.setMessage}
				sendMessage={this.sendMessage}
				companyName={this.state.companyName}
				address={this.state.address}
				contactNo={this.state.contactNo}
				status={this.state.status}
				name={this.state.name}
				message={this.state.message}
				email={this.state.email}
				topic={this.state.topic} />
		);
	} else {
		return (
			<ContactUsDesktop {...this.props}
				setTopic={this.setTopic}
				setName={this.setName}
				setEmail={this.setEmail}
				setMessage={this.setMessage}
				sendMessage={this.sendMessage}
				companyName={this.state.companyName}
				address={this.state.address}
				contactNo={this.state.contactNo}
				status={this.state.status}
				name={this.state.name}
				message={this.state.message}
				email={this.state.email}
				topic={this.state.topic}/>
		);
	}

  }
}
